var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"dept",staticClass:"tree-border",attrs:{"data":_vm.deptOptions,"show-checkbox":"","default-expand-all":"","node-key":"dpt_id","check-strictly":_vm.checkStrictly,"empty-text":"加载中，请稍后","props":_vm.deptProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }